module.exports = __webpack_public_path__ + "img/testPhone_d.f0402691.png";